import { render, staticRenderFns } from "./ExchangeRateInfoSection.vue?vue&type=template&id=0987f151&scoped=true"
import script from "./ExchangeRateInfoSection.vue?vue&type=script&lang=js"
export * from "./ExchangeRateInfoSection.vue?vue&type=script&lang=js"
import style0 from "./ExchangeRateInfoSection.vue?vue&type=style&index=0&id=0987f151&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0987f151",
  null
  
)

export default component.exports